// Permission mapping between legacy/backend keys and route-required keys

export const permissionMap: Record<string, string> = {
  // 风险监控
  riskMonitor_read: "fundRiskMonitorV2_read",
  fundRiskMonitorV2_read: "fundRiskMonitorV2_read",

  // 成交信息
  tradeInfo_read: "pendingOrderTradeTable_read",
  pendingOrderTradeTable_read: "pendingOrderTradeTable_read",

  // 期现套利 - 已移除 (2025-12-23)
  // tradeRecord_read: "tradeRecord_read",

  // 折溢价套利
  priceArbitrage_read: "priceArbitrage_read",
  priceArbitrage_read_update: "priceArbitrage_read", // 拥有读写权限也能访问只读路由

  // 折溢价操作台
  priceArbitrageConsole_read: "priceArbitrageConsole_read",

  // 波动率交易
  volatilityTrading_read: "volatilityTrading_read",

  // 转债套利
  convertibleBond_read: "convertBondArb_read",
  convertBondArb_read: "convertBondArb_read",
  convertBondArb_read_update: "convertBondArb_read", // 拥有读写权限也能访问只读路由

  // 双腿价差
  dualLeg_read: "duallegTrader_read",
  duallegTrader_read: "duallegTrader_read",
  duallegTrader_read_update: "duallegTrader_read", // 拥有读写权限也能访问只读路由

  // PCP多账户
  pcpMulti_read: "pcpMulti_read_update",
  pcpMulti_read_update: "pcpMulti_read_update",
  pcp_multi_read: "pcpMulti_read_update",
  pcp_multi_read_update: "pcpMulti_read_update",

  // PCP实时监控 - 拥有 pcpMulti_read_update 权限的用户也可以访问
  pcpMulti_realtime_monitor_read: "pcpMulti_realtime_monitor_read",
  // 如果用户有 pcpMulti_read_update，也允许访问实时监控
  "pcpMulti_read_update->pcpMulti_realtime_monitor_read": "pcpMulti_realtime_monitor_read",

  // PCP基差工作台 - 独立权限 token（与 PCP 主权限解耦）
  pcpMulti_basis_workbench_read_update: "pcpMulti_basis_workbench_read_update",
  pcp_multi_basis_workbench_read_update: "pcpMulti_basis_workbench_read_update",

  // ETF-T0
  etfT0_read: "etfT0_read",
  etfT0_read_update: "etfT0_read", // 拥有读写权限也能访问只读路由

  // 期货价差
  futuresSpread_read: "futuresSpread_read",
  futuresSpread_read_update: "futuresSpread_read", // 拥有读写权限也能访问只读路由

  // ETF手工申赎
  futureEtfControlPanel_read: "futureEtfControlPanel_read",
  futureEtfControlPanel_read_update: "futureEtfControlPanel_read", // 拥有读写权限也能访问只读路由

  // 跨期策略
  calendarStrategy_read: "futureCalStrategy_read",
  futureCalStrategy_read: "futureCalStrategy_read",
  futureCalStrategy_read_update: "futureCalStrategy_read", // 拥有读写权限也能访问只读路由

  // 清算信息
  accounts_read: "FundEquity_read",
  FundEquity_read: "FundEquity_read",

  // 场外头寸管理
  otcMargin_read: "otcMarginMng_read",
  otcMarginMng_read: "otcMarginMng_read",
  otcMarginMng_update: "otcMarginMng_read", // 拥有管理权限也能访问只读路由

  // ETF申赎监控
  etfMonitor_read: "EtfConvertMonitor_read",
  EtfConvertMonitor_read: "EtfConvertMonitor_read",

  // 现金管理
  cashTargetMng_read: "cashTargetMng_read",
  cashTargetMng_read_update: "cashTargetMng_read", // 拥有读写权限也能访问只读路由

  // ETF折溢价回测
  etfBacktest_read: "etfConvertBacktest_read",
  etfConvertBacktest_read: "etfConvertBacktest_read",
  etfConvertBacktest_read_update: "etfConvertBacktest_read", // 修复：拥有读写权限的用户也能访问只读路由

  // AI交易驾驶舱
  copilot_read: "copilot_read_update",
  copilot_view: "copilot_read_update",
  copilot_read_update: "copilot_read_update",
  ai_copilot_read: "copilot_read_update",

  // 套利日报
  report_daily_view: "report_daily_view",
  report_daily_update: "report_daily_update",

  // 日报区域权限
  report_daily_core_metrics: "report_daily_core_metrics",
  report_daily_account_turnover: "report_daily_account_turnover",
  report_daily_position_analysis: "report_daily_position_analysis",
  report_daily_order_latency: "report_daily_order_latency",
  report_daily_position_diff: "report_daily_position_diff",
  report_daily_logic_profit: "report_daily_logic_profit",
  report_daily_open_close_profit: "report_daily_open_close_profit",
  report_daily_logic_action: "report_daily_logic_action",
  report_daily_review_plan: "report_daily_review_plan",
  report_daily_strategy_summary: "report_daily_strategy_summary",
  report_daily_cb_trades: "report_daily_cb_trades",

  // 权限管理
  permission_manage: "permission_manage",
  permission_read: "permission_manage",
  permission_read_update: "permission_manage",
  permission_view: "permission_manage",
  permissions_read: "permission_manage",
  permissions_view: "permission_manage",

  // ETF现金偏差与涨跌停盈亏
  etf_cashdif_limit_pnl_read: "etf_cashdif_limit_pnl_read",

  // 变体别名（更宽松的清算信息/申赎等）
  fund_equity_read: "FundEquity_read",
  etf_convert_monitor_read: "EtfConvertMonitor_read",
  etf_convert_backtest_read: "etfConvertBacktest_read",
  trade_info_read: "pendingOrderTradeTable_read",
  convert_bond_arb_read: "convertBondArb_read",
};

export function normalizePermissions(perms: string[]): string[] {
  const out = new Set<string>();
  for (let p of perms || []) {
    if (!p) continue;
    // trim
    p = String(p).trim();
    if (!p) continue;
    // normalize separators and case for resource/action forms
    // examples: "fundRiskMonitorV2:read" -> "fundRiskMonitorV2_read"
    //           "fund-risk-monitor-v2.READ" -> "fundriskmonitorv2_read"
    const normalizedForm = p.replace(/[:./\-\s]+/g, "_").replace(/__+/g, "_");
    const parts = normalizedForm.split("_");
    if (parts.length >= 2) {
      const action = parts.pop() as string;
      const resource = parts.join("_");
      p = `${resource}_${action.toLowerCase()}`;
    } else {
      p = normalizedForm;
    }

    // direct map
    if (permissionMap[p]) {
      out.add(permissionMap[p]);
      continue;
    }
    // try case-insensitive match
    const lower = p.toLowerCase();
    const found = Object.keys(permissionMap).find((k) => k.toLowerCase() === lower);
    if (found) {
      out.add(permissionMap[found]);
      continue;
    }
    // if already canonical-like, keep
    if (/_[a-z]+$/.test(p)) {
      out.add(p);
    }
  }
  return Array.from(out);
}
